(function(){
  function pad(n){return String(n).padStart(2,'0')}
  function tickCountdown(el){
    var date = el.getAttribute('data-duckrace-date');
    if(!date) return;
    var target = new Date(date).getTime();
    if(isNaN(target)) return;
    function update(){
      var diff = Math.max(0,target - Date.now());
      var days = Math.floor(diff/86400000);
      var hours = Math.floor(diff%86400000/3600000);
      var minutes = Math.floor(diff%3600000/60000);
      var seconds = Math.floor(diff%60000/1000);
      el.querySelector('[data-days]').textContent = days;
      el.querySelector('[data-hours]').textContent = pad(hours);
      el.querySelector('[data-minutes]').textContent = pad(minutes);
      el.querySelector('[data-seconds]').textContent = pad(seconds);
    }
    update(); setInterval(update,1000);
  }
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-duckrace-countdown]').forEach(tickCountdown);
  });
})();
